import { useSelector } from 'react-redux';

import { amplitudeContextSelector } from '@/features/amplitude/store/amplitude.ts';
import { GameFrame } from '@/features/game-client/game-frame';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { buildLnwUrl } from '@/features/providers/lnw/lnw-url-builder';
import { FGPLnwLaunchData } from '@/features/providers/lnw/types';
import { GameDataProp } from '@/features/providers/types';
import { useAppSelector } from '@/store/hooks';

export const Lnw: React.FC<GameDataProp> = ({ data }: GameDataProp) => {
  const isNetPositionEnabled = useSelector(amplitudeContextSelector)?.netPositionLnWHandling === 'enabled';

  const url = buildLnwUrl(data as FGPLnwLaunchData, isNetPositionEnabled);
  const { gameName } = useAppSelector(gameContextSelector);

  return <GameFrame title={gameName} url={url} />;
};
